export const RESET_STATE = 'root/RESET_STATE';
